import React, { useState, useEffect, useCallback } from "react";
import { Form, Button, Select, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Filterloader from "../../../../components/loaderFilter";
import { breakPlainOptionsreason } from "../../../../utils/Helpers";
import * as zoneActions from "../../../../redux/actions/zone.actions";
import * as BreakActions from "../../../../redux/actions/break.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";

const getDefaultFilter = (limit = 10) => ({
  storeIds: [],
  status: [],
  keysearch: "",
  zones: [],
  riderId: "",
  reasons: [],
  currentPage: 1,
  limit,
  startDate: moment(),
  endDate: moment(),
});

const BreakFilters = (props) => {
  const [loading, setLoading] = useState(false);
  const [postDataZone, setPostDataZone] = useState([]);
  const [postDataZoneIdsAll, setPostDataZoneIdsAll] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    postLists();
  }, []);

  useEffect(() => {
    if (props.storeIdsFilter) {
      form.setFieldsValue({
        keysearch: props.storeIdsFilter.keysearch || "",
        zones: props.storeIdsFilter.zones || [],
        riderId: props.storeIdsFilter.riderId || "",
        reasons: props.storeIdsFilter.reasons || [],
      });
    }
  }, [props.storeIdsFilter]);

  const postLists = useCallback(async () => {
    try {
      setLoading(true);
      await props.zoneActions.getZoneListAction();
    } catch (e) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      const zoneDataAll = [];
      props.zoneData.forEach((item) => {
        const zoneId = item?.id ? String(item.id) : null;
        if (!zoneId) return;
        zoneData.push({ value: zoneId, label: item?.zoneName || zoneId });
        zoneDataAll.push(zoneId);
      });
      setPostDataZoneIdsAll(zoneDataAll);
      setPostDataZone([{ value: "all", label: "---SELECT ALL---" }, ...zoneData]);
    }
  }, [props.zoneData]);

  const onChangeHandelZone = (value) => {
    if (value?.includes("all")) {
      form.setFieldsValue({
        zones: postDataZoneIdsAll,
      });
    }
  };

  const filterChange = async (value) => {
    const pageData = {
      ...getDefaultFilter(props.storeIdsFilter?.limit || 10),
      ...props.storeIdsFilter,
      ...value,
      keysearch: (value?.keysearch || "").trim(),
      zones: value?.zones || [],
      riderId: value?.riderId || "",
      reasons: value?.reasons || [],
      currentPage: 1,
    };
    try {
      setLoading(true);
      await props.BreakActions.breakListFilterAction(pageData);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const filterreset = async () => {
    const pageData = getDefaultFilter(props.storeIdsFilter?.limit || 10);
    form.setFieldsValue({
      keysearch: "",
      zones: [],
      riderId: "",
      reasons: [],
    });
    try {
      setLoading(true);
      await props.BreakActions.breakListFilterAction(pageData);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  return loading && !postDataZone.length ? (
    <Filterloader />
  ) : (
    <Form
      form={form}
      className="fliters_form"
      disabled={loading}
      onFinish={filterChange}
      layout="vertical"
    >
      <Form.Item name="keysearch" label="Search">
        <Input
          allowClear
          placeholder="Shift ID, Name, Reason"
          style={{ width: 240 }}
        />
      </Form.Item>
      <Form.Item name="zones" label="Zone">
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={postDataZone}
          onChange={onChangeHandelZone}
          style={{ minWidth: 300 }}
          placeholder="Please select Zone"
        />
      </Form.Item>
      <Form.Item name="riderId" label="Rider ID">
        <Input allowClear placeholder="Rider ID" style={{ width: 140 }} />
      </Form.Item>
      <Form.Item name="reasons" label="Break Reasons">
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={breakPlainOptionsreason}
          style={{ minWidth: 240 }}
          placeholder="Break Reasons"
        />
      </Form.Item>
      <Button htmlType="submit" loading={loading}>
        Search <SearchOutlined />
      </Button>
      <Button loading={loading} onClick={filterreset}>
        Reset
      </Button>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
    storeIdsFilter: state.BreakReducer.taskFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    BreakActions: bindActionCreators(BreakActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BreakFilters);
